import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IBusinessNamesResponse } from '../models/business-names.model';
import { fromStaticDataBusinessNamesActions } from '../actions';

export const businessNamesFeatureKey = 'businessNames';

export interface BusinessNamesState {
  businessNamesResponse: IBusinessNamesResponse[];
  businessNamesFailure: IGenericError<ErrorResponse>;
}

export const initialState: BusinessNamesState = {
  businessNamesResponse: undefined,
  businessNamesFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataBusinessNamesActions.loadBusinessNamesSuccess, (state, action) => ({
    ...state,
    businessNamesResponse: action.response
  })),

  on(fromStaticDataBusinessNamesActions.loadBusinessNamesFailure, (state, action) => ({
    ...state,
    businessNamesFailure: action.error
  }))
);

export const getStaticDataBusinessNamesResponse = (state: BusinessNamesState) => state.businessNamesResponse;
export const getStaticDataBusinessNamesFailure = (state: BusinessNamesState) => state.businessNamesFailure;
